import { styled } from 'styled-system/jsx'

const FieldContainer = styled('label', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    minWidth: '0',
  },
})

const FieldLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.ink',
  },
})

const InputRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    borderRadius: 'sm',
    backgroundColor: '#FFFFFF',
    paddingX: '14px',
    paddingY: '0',
    transition:
      'border-color {durations.fast} {easings.appleStandard}, box-shadow {durations.fast} {easings.appleStandard}',
    _focusWithin: {
      borderColor: 'quickpass.primary',
      boxShadow: '0 0 0 4px rgba(128, 84, 255, 0.12)',
    },
  },
  variants: {
    hasError: {
      true: {
        borderColor: 'quickpass.warmth',
        _focusWithin: {
          borderColor: 'quickpass.warmth',
          boxShadow: '0 0 0 4px rgba(255, 139, 115, 0.18)',
        },
      },
    },
  },
})

const Prefix = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '16px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
  },
})

const NumberInputElement = styled('input', {
  base: {
    flex: '1',
    minWidth: '0',
    width: '100%',
    fontFamily: 'body',
    fontSize: '16px',
    paddingY: '12px',
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    color: 'quickpass.ink',
    appearance: 'textfield',
    _placeholder: {
      color: '#B8B0CC',
      opacity: '1',
    },
  },
})

const HelperText = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
  },
  variants: {
    isError: {
      true: {
        color: 'quickpass.warmth',
        fontWeight: '600',
      },
    },
  },
})

export {
  FieldContainer,
  FieldLabel,
  InputRow,
  Prefix,
  NumberInputElement,
  HelperText,
}
